<!-- <p>evaluation-pv works!</p> -->
<div class="content-pv">
    <div class="header">
        <!-- <img [src]="imageLogo" alt="Logo" class="logo" style="width:300px; float:left;"> -->
        <img
                alt="Logo"
                src="/assets/media/logos/wegestu.png"
                class="h-125px"
              />
        <h2>PV WEGESTU</h2>
    </div>
    
    <div class="top-section">
        <div class="detail"> 
            Detail PV:PV-{{ numeroPv }}
        </div>
        <div class="row header-pv">
            <div class="col-6">
                <div class="row">
                    <div class="col-6 title">
                        <div>Nom</div>
                        <div>Type</div>
                        <div>Date d'envoi</div>
                        <div>Date de réception</div>
                        <div>Date remplissage compte rendu</div>
                    </div>
                    <div class="col-6 content">
                        <div> {{ nom }} </div>
                        <div> {{ type }} </div>
                        <div> {{ dateEnvoi }} </div>
                        <div> {{ dateReception }} </div>
                        <div> {{ dateCompteRendu }} </div>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="row">
                    <div class="col-6 title">
                        <div>Nom</div>
                        <div>Type</div>
                        <div>Date d'envoi</div>
                        <div>Date de réception</div>
                        <div>Date remplissage compte rendu</div>
                    </div>
                    <div class="col-6 content">
                        <div> {{ nom }} </div>
                        <div> {{ type }} </div>
                        <div> {{ dateEnvoi }} </div>
                        <div> {{ dateReception }} </div>
                        <div> {{ dateCompteRendu }} </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="evaluation" *ngIf="evaluation.length">
        <div *ngFor="let eval of evaluation">
            <div *ngIf="hasValidSubjects(eval)">
                <div class="eval-section">
                    <h3 class="subject-title" *ngIf="eval.subjectTitle && eval.subjectTitle.length > 4">
                        {{ eval.subjectTitle }}
                    </h3>
                    <div class="subject-content" *ngFor="let subject of eval.subject; let i = index">
                        <div class="question-content">
                            <h5>
                                <span class="question-counter">{{ i + 1 }}-</span> 
                                <span class="question">{{ subject.question }}</span>
                            </h5>
                            <div class="stars" *ngIf="subject.stars > 0">
                                <img *ngFor="let star of [].constructor(subject.stars)" [src]="starImage" alt="star">
                                <img *ngFor="let empty of [].constructor(5 - subject.stars)" [src]="starInactiveImage" alt="star inactive">
                            </div>
                        </div>
                          
                            <p class="subject-description">{{ subject?.comment }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    

    <div class="detail compte-rendu">
        <h3>Compte rendu</h3>
        
    </div>
    <div>{{ comment }}</div>
    <div class="signature clearfix">
        <div class="signature-box">
            <h3>Signature par ESN</h3>
            <img [src]="signatureImage" alt="signature">
            <p>{{ nameEsn }}</p>
            <p>{{ dateEsn }}</p>
        </div>

        <div class="signature-box">
            <h3>Signature par consultant</h3>
            <img [src]="signatureImage" alt="signature">
            <p>{{ nameConsultant }}</p>
            <p>{{ dateConsultant }}</p>
        </div>
    </div>
</div>
